import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { PagedResult } from '@app/shared/models/paged-result';
import { Tenant } from '../models/tenant.model';
import { TenantQueryViewModel } from '../models/tenant-query-view-model.model';

@Injectable()
export class TenantService {
  private http = inject(HttpClient);
  private baseURL = environment.apiUrl + 'tenant';

  getById(id: number): Observable<Tenant> {
    return this.http.get<Tenant>(`${this.baseURL}/${id}`);
  }

  addTenant(payload: FormData): Observable<Tenant> {
    return this.http.post<Tenant>(`${this.baseURL}`, payload);
  }

  updateTenant(id: number, payload: FormData): Observable<Tenant> {
    return this.http.put<Tenant>(`${this.baseURL}/${id}`, payload);
  }

  changeTenantStatus(id: number): Observable<Tenant> {
    return this.http.patch<Tenant>(`${this.baseURL}/${id}/status`, null);
  }

  private buildParams(query: TenantQueryViewModel): HttpParams {
    let params = new HttpParams()
      .set('pageIndex', query.pageIndex ?? 1)
      .set('pageSize', query.pageSize ?? 10);

    if (query.searchKey !== undefined) {
      params = params.set('searchKey', query.searchKey.toString());
    }
    if (query.search) {
      params = params.set('search', query.search);
    }
    if (query.sortBy !== undefined) {
      params = params.set('sortBy', query.sortBy.toString());
    }
    if (query.sortDirection !== undefined) {
      params = params.set('sortDirection', query.sortDirection.toString());
    }
    if (query.isActive !== undefined) {
      params = params.set('isActive', query.isActive.toString());
    }

    return params;
  }

  getPaginatedData(
    query: TenantQueryViewModel
  ): Observable<PagedResult<Tenant>> {
    return this.http.get<PagedResult<Tenant>>(`${this.baseURL}/paginated`, {
      params: this.buildParams(query),
    });
  }

  exportData(query: TenantQueryViewModel): Observable<Blob> {
    return this.http.get(`${this.baseURL}/export`, {
      params: this.buildParams(query),
      responseType: 'blob',
    });
  }
}
